webpackJsonp([1],{

/***/ "+dOB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: '',
      location: '',
      imageUrl: '',
      description: '',
      date: new Date(),
      time: new Date(),
      image: null,
      category: '',
      stageNo: 0,
      tag: '',
      type: '',
      link: ''
    };
  },

  computed: {
    formIsValid: function formIsValid() {
      return this.title !== '' && this.location !== '' && this.imageUrl !== '' && this.description !== '' && this.category !== '' && this.stageNo !== null && this.tag !== '' && this.type !== '' && this.link !== '';
    },
    submittableDateTime: function submittableDateTime() {
      var date = new Date(this.date);
      if (typeof this.time === 'string') {
        var hours = this.time.match(/^(\d+)/)[1];
        var minutes = this.time.match(/:(\d+)/)[1];
        date.setHours(hours);
        date.setMinutes(minutes);
      } else {
        date.setHours(this.time.getHours());
        date.setMinutes(this.time.getMinutes());
      }
      return date;
    }
  },
  methods: {
    onCreateMeetup: function onCreateMeetup() {
      if (!this.formIsValid) {
        return;
      }
      if (!this.image) {
        return;
      }
      var meetupData = {
        title: this.title,
        category: this.category,
        stageNo: this.stageNo,
        tag: this.tag,
        type: this.type,
        link: this.link,
        location: this.location,
        // imageUrl: this.imageUrl,
        image: this.image,
        description: this.description,
        date: this.submittableDateTime
      };
      this.$store.dispatch('createMeetup', meetupData);
      this.$router.push('/home');
    },
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked: function onFilePicked(event) {
      var _this = this;

      var file = event.target.files;
      var filename = file[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(file[0]);
      this.image = file[0];
    },
    onCancel: function onCancel() {
      this.$router.push('/home');
    }
  }
});

/***/ }),

/***/ "//Sg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-back-to-top",on:{"click":_vm.backToTop}},[_c('span',[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/XfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stagePhoto_vue__ = __webpack_require__("mJcB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723ef8fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stagePhoto_vue__ = __webpack_require__("KbQx");
function injectStyle (ssrContext) {
  __webpack_require__("1X9b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-723ef8fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stagePhoto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723ef8fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stagePhoto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "03pU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  methods: {
    onClose: function onClose() {
      this.$emit('dismissed');
    }
  }
});

/***/ }),

/***/ "1X9b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "36GZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'Voltar ao topo'
    },
    visibleOffset: {
      type: [String, Number],
      default: 600
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  /**
   * Catch window scroll event 
   * @return {void}
   */
  created: function created() {
    var _this = this;

    var catchScroll = function catchScroll() {
      _this.visible = window.pageYOffset > parseInt(_this.visibleOffset);
    };

    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    };

    window.onscroll = catchScroll;
  },

  methods: {
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
    }
  }
});

/***/ }),

/***/ "4iN8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px","persistent":""},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-btn',{attrs:{"slot":"activator","small":""},slot:"activator"},[_c('v-icon',[_vm._v("edit")]),_vm._v(" Text\n  ")],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-title',[_vm._v("Edit Meetup")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","required":""},model:{value:(_vm.editedTitle),callback:function ($$v) {_vm.editedTitle=$$v},expression:"editedTitle"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","required":""},model:{value:(_vm.editedDescription),callback:function ($$v) {_vm.editedDescription=$$v},expression:"editedDescription"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"category","label":"Category","id":"category","required":""},model:{value:(_vm.editedCategory),callback:function ($$v) {_vm.editedCategory=$$v},expression:"editedCategory"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"tag","label":"Tag","id":"tag","required":""},model:{value:(_vm.editedTag),callback:function ($$v) {_vm.editedTag=$$v},expression:"editedTag"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"stageNo","label":"StageNo","id":"stageNo","required":""},model:{value:(_vm.editedStageNo),callback:function ($$v) {_vm.editedStageNo=$$v},expression:"editedStageNo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"type","label":"Type","id":"type","required":""},model:{value:(_vm.editedType),callback:function ($$v) {_vm.editedType=$$v},expression:"editedType"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-actions',[_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":_vm.onSaveChanges}},[_vm._v("Save")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5S4j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      postYear: ''

    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    error: function error() {
      return this.$store.getters.error;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    }
  },
  methods: {
    onSignin: function onSignin() {
      this.$store.dispatch('signUserIn', { email: this.email, password: this.password });
    },
    onLogout: function onLogout() {
      this.$router.push('/home');
    },
    onDismissed: function onDismissed() {
      this.$store.dispatch('clearError');
    }
  }
});

/***/ }),

/***/ "5TPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var date = new Date(value);
  //  return date.toLocaleString(['en-US'], {month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
  return date.toLocaleString(['ja-JP'], { month: 'short', day: '2-digit', year: 'numeric' });
  // return date.toLocaleString("ja-JP",{hour12:false})
  // return date.toLocaleString("ja-JP-u-ca-japanese")
});

/***/ }),

/***/ "62Cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  methods: {
    goBack: function goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    }
  },
  computed: {
    meetup: function meetup() {
      return this.$store.getters.loadedMeetup(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.meetup.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }

});

/***/ }),

/***/ "7TUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "8veW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.awards),function(award){return (_vm.id == award.type)?_c('v-flex',{key:award.id,attrs:{"xs12":"","sm12":"","md12":"","lg12":"","x12":""}},[_c('div',{staticClass:"page-title pt-3"},[_vm._v("AWARDS "),_c('span',{staticClass:"title-bar"},[_vm._v("|")]),_vm._v(" "+_vm._s(award.title))])]):_vm._e()}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","x12":""}},[_c('v-card',{staticClass:"grid card-block"},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.meetupsFiltersType),function(meetup){return (meetup.type == _vm.id  &&  _vm.getYear( meetup.date) == '2017')?_c('v-flex',{key:meetup.id,staticClass:"image-inner",attrs:{"xs12":"","sm12":"","md6":"","lg4":"","xl4":"","meetupType":meetup.type}},[_c('div',{staticClass:"image-border"},[_c('img',{staticClass:"image",staticStyle:{"cursor":"pointer"},attrs:{"src":meetup.imageUrl,"alt":meetup.title},on:{"click":function($event){_vm.onLoadMeetup(meetup.id)}}}),_vm._v(" "),_c('p',{staticClass:"image-cap "},[_vm._v(" "+_vm._s(meetup.title))])])]):_vm._e()}))],1),_vm._v(" "),_c('br')],1)],1)],2),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"left"},attrs:{"xs12":"","sm12":"","md6":"","lg4":"","xl4":""}},[_c('v-btn',{on:{"click":function($event){_vm.goBack(_vm.meetupType)}}},[_vm._v("\n              Back\n                "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Arj8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      awards: [{ imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0208b1x1.jpg',
        id: 1,
        title: 'BEST TITLE',
        titleJp: 'タイトル部門',
        subTitle: 'Select the best title image from all the stages',
        subTitleJp: '２０１７年に投稿した１１ステージのタイトル画像から最も気に入っているデザインを選びました。',
        type: 'awStage'
      }, { imageUrl: ' http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0259.jpg',
        id: 2,
        title: 'BEST STAGE',
        titleJp: 'ベストステージ部門',
        subTitle: 'Select the best post image from all the stages',
        subTitleJp: '各ステージの中から一番のお気に入りを選びました。',
        type: 'awPost'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2931.jpg',
        id: 3,
        title: 'BEST DAYTIME',
        titleJp: 'デイタイム部門',
        subTitle: 'Select the best Daytime image from all the stages',
        subTitleJp: '昼間のシーンからお気に入りを選びました。',
        type: 'awDaytime'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/b_road_panorama1b.jpg',
        id: 4,
        title: 'BEST TWILIGHT',
        titleJp: 'トワイライト部門',
        subTitle: 'Select the best twilight image from all the stages',
        subTitleJp: '夕暮れのシーンからお気に入りを選びました。',
        type: 'awTwilite'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img9665.jpg',
        id: 5,
        title: 'BEST NIGHT',
        titleJp: 'ナイト部門',
        subTitle: 'Select the best night image from all the stages',
        subTitleJp: '夜景の中からお気に入りを選びました。',
        type: 'awNight'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',
        id: 6,
        title: 'BEST VEHICLE',
        titleJp: 'ビークル部門',
        subTitle: 'Select the best vehicle image from all the stages',
        subTitleJp: '車、船など乗り物の画像から一番のお気に入りを選びました。',
        type: 'awVehicle'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/img1875base.jpg',
        id: 7,
        title: 'BEST COMPOSIT',
        titleJp: '合成部門',
        subTitle: 'Select the best composit image from all the stages',
        subTitleJp: '３Dモデルの画像合成、アニメーション画像から一番のお気に入りを選びました。',
        type: 'awComposit'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img0749a1x1.jpg',
        id: 8,
        title: 'BEST HDR',
        titleJp: 'ＨＤＲ部門',
        subTitle: 'Select the best HDR image from all the stages',
        subTitleJp: 'すべてのＨＤＲ画像から一番のお気に入りを選びました。',
        type: 'awHdr'
      }]
    };
  },


  computed: {
    meetups: function meetups() {
      return this.$store.getters.featuredMeetups;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    onLoadMeetupPost: function onLoadMeetupPost(id) {
      //  console.log('top onLoadMeetupPost id ' + id)
      // this.$router.push('/title/' + id)
      this.$router.push('/entry/' + id);
    },
    onLoadMeetupAwards: function onLoadMeetupAwards(id) {
      //  console.log('top onLoadMeetupAwards Type ' + id)
      // this.$router.push('/title/' + id)
      this.$router.push('/best/' + id + '#top');
      // this.$router.push('/thumnail/' + id)
    },
    onTop: function onTop() {
      //  console.log('top onLoadMeetupAwards Type ' + id)
      // this.$router.push('/title/' + id)
      this.$router.push('/#page-top');
      // this.$router.push('/thumnail/' + id)
    }
  }

});

/***/ }),

/***/ "Cpyz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['meetup'],
  data: function data() {
    return {
      editDialog: false,
      editedTitle: this.meetup.title,
      editedDescription: this.meetup.description,
      editedCategory: this.meetup.category,
      editedTag: this.meetup.tag,
      editedStageNo: this.meetup.stageNo,
      editedType: this.meetup.type
    };
  },

  methods: {
    onSaveChanges: function onSaveChanges() {
      if (this.editedTitle.trim() === '' || this.editedDescription.trim() === '' || this.editedCategory.trim() === '' || this.editedTag.trim() === '' || this.editedStageNo.trim() === '' || this.editedType.trim() === '') {
        return;
      }
      this.editDialog = false;
      this.$store.dispatch('updateMeetupData', {
        id: this.meetup.id,
        title: this.editedTitle,
        description: this.editedDescription,
        category: this.editedCategory,
        tag: this.editedTag,
        stageNo: this.editedStageNo,
        type: this.editedType
      });
    }
  }
});

/***/ }),

/***/ "CrjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stageThumnail_vue__ = __webpack_require__("HMxF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f112ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stageThumnail_vue__ = __webpack_require__("IxJE");
function injectStyle (ssrContext) {
  __webpack_require__("IzAZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77f112ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stageThumnail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f112ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_stageThumnail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_695508ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("kgXP");
function injectStyle (ssrContext) {
  __webpack_require__("zh4g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_695508ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E/Wt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__ = __webpack_require__("36GZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7bf04369_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__ = __webpack_require__("//Sg");
function injectStyle (ssrContext) {
  __webpack_require__("S25E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BackToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7bf04369_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BackToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E4rV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl8":""}},[_c('v-card',{staticStyle:{"background-color":"rgba(38, 50, 56, 1)"}},[_c('img',{attrs:{"src":_vm.meetup.imageUrl,"width":"100%","height":"auto","alt":_vm.meetup.title}}),_vm._v(" "),_c('v-card-title',[_c('div',[_c('h5',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.meetup.title))]),_vm._v(" "),_c('p',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.meetup.description))])])]),_vm._v(" "),_c('v-card-title',{staticClass:"pb-0"},[_c('div',[_c('span',{staticClass:"white--text pr-2"},[_vm._v(" "+_vm._s(_vm.meetup.category)+" ")]),_vm._v(" "),_c('v-icon',[_vm._v("place")]),_c('span',{staticClass:"white--textpr pr-2"},[_vm._v(" "+_vm._s(_vm.meetup.tag)+" ")]),_vm._v(" "),_c('v-icon',[_vm._v("event")]),_c('span',{staticClass:"white--text pr-2"},[_vm._v(" "+_vm._s(_vm._f("date")(_vm.meetup.date))+" ")])],1)]),_vm._v(" "),_c('v-card-title',{staticClass:"pt-1"},[_c('div',[_c('a',{attrs:{"href":_vm.meetup.link,"target":"_blank"}},[_c('p',{staticClass:"image-link white--text"},[_vm._v("Blog Page"),_c('v-icon',{attrs:{"color":"white darken-1"}},[_vm._v("chevron_right")])],1)])])]),_vm._v(" "),(_vm.userIsCreator)?[_c('v-spacer'),_vm._v(" "),_c('app-edit-details-dialog',{attrs:{"meetup":_vm.meetup}}),_vm._v(" "),_c('app-edit-date-dialog',{attrs:{"meetup":_vm.meetup}})]:_vm._e()],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"left"},attrs:{"xs12":"","lg8":"","xl8":""}},[_c('v-btn',{on:{"click":_vm.goBack}},[_vm._v("\n                Back\n                  "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F7mD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl8":""}},[_c('v-card',[_c('img',{attrs:{"src":_vm.meetup.imageUrl,"width":"100%","height":"auto"}}),_vm._v(" "),_c('v-card-title',[_c('div',[_c('h5',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.meetup.title))]),_vm._v(" "),_c('p',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.meetup.description))])])]),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',{staticClass:"white--text"},[_vm._v("Stage"+_vm._s(_vm.meetup.stageNo)+" ")]),_vm._v(" "),_c('span',{staticClass:"white--text pr-2"},[_vm._v(" "+_vm._s(_vm.meetup.category)+" ")]),_vm._v(" "),_c('v-icon',[_vm._v("place")]),_c('span',{staticClass:"white--textpr pr-2"},[_vm._v(" "+_vm._s(_vm.meetup.tag)+" ")]),_vm._v(" "),_c('v-icon',[_vm._v("event")]),_c('span',{staticClass:"white--text pr-2"},[_vm._v(" "+_vm._s(_vm._f("date")(_vm.meetup.date))+" ")])],1)]),_vm._v(" "),_c('v-card-title',{staticClass:"pt-1"},[_c('div',[_c('a',{attrs:{"href":_vm.meetup.link,"target":"_blank"}},[_c('p',{staticClass:"image-link white--text"},[_vm._v("Blog Page"),_c('v-icon',{attrs:{"color":"white darken-1"}},[_vm._v("chevron_right")])],1)])])]),_vm._v(" "),(_vm.userIsCreator)?[_c('v-spacer'),_vm._v(" "),_c('app-edit-details-dialog',{attrs:{"meetup":_vm.meetup}}),_vm._v(" "),_c('app-edit-date-dialog',{attrs:{"meetup":_vm.meetup}})]:_vm._e()],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"left"},attrs:{"xs12":"","lg8":"","xl8":""}},[_c('v-btn',{on:{"click":_vm.goBack}},[_vm._v("\n                Back\n                  "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  // data () {
  // return {
  // meetups: [
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2016/12/shishimai_title1.jpg',id:1, title:'獅子舞'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/02/kobe_again_title_stage2.jpg',id:2, title:'ＫＯＢＥ ＡＧＡＩＮ'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/03/rusted_car_title2.jpg',id:3, title:'ＲＵＳＴＥＤ ＣＡＲ'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',id:4, title:'Vintage Car'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/04/retoro_car_title.jpg',id:5, title:'ＲＥＴＲＯ ＣＡＲ'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/Stage6_title.jpg',id:6, title:'瀬戸埠頭の見える岬でＨＤＲ'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/haruyoi_title2.jpg',id:7, title:'倉敷春宵あかり'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/tamanoFes_title21.jpg',id:8, title:'たまの港フェスティバルでＨＤＲ'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/a-bombe-dome.jpg',id:9, title:'Ａ‐ＢＯＭＢ ＤＯＭＥ'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/broad_title3.jpg',id:10, title:'黒島ビーナスロード'},
  //     {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2946_title10.jpg',id:11, title:'Building in Sky'}
  // ]
  // }
  // },
  computed: {
    meetups: function meetups() {
      return this.$store.getters.featuredMeetups;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    onLoadMeetup: function onLoadMeetup(id) {
      console.log('onLoadMeetup id ' + id);
      this.$router.push('/stageThumnail/' + id);
    }
  }
});

/***/ }),

/***/ "HIvf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_awardsBest_vue__ = __webpack_require__("P8GW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afa1d2a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_awardsBest_vue__ = __webpack_require__("nnto");
function injectStyle (ssrContext) {
  __webpack_require__("cHSO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afa1d2a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_awardsBest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afa1d2a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_awardsBest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HMxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  data: function data() {
    return {

      awards: [{ imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0208b1x1.jpg',
        id: 1,
        title: 'BEST TITLE',
        titleJp: 'タイトル部門',
        subTitle: 'Select the best title image from all the stages',
        subTitleJp: '２０１７年に投稿した１１ステージのタイトル画像から最も気に入っているデザインを選びました。',
        type: 'awStage'
      }, { imageUrl: ' http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0259.jpg',
        id: 2,
        title: 'BEST STAGE',
        titleJp: 'ベストステージ部門',
        subTitle: 'Select the best post image from all the stages',
        subTitleJp: '各ステージの中から一番のお気に入りを選びました。',
        type: 'awPost'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2931.jpg',
        id: 3,
        title: 'BEST DAYTIME',
        titleJp: 'デイタイム部門',
        subTitle: 'Select the best Daytime image from all the stages',
        subTitleJp: '昼間のシーンからお気に入りを選びました。',
        type: 'awDaytime'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/b_road_panorama1b.jpg',
        id: 4,
        title: 'BEST TWILIGHT',
        titleJp: 'トワイライト部門',
        subTitle: 'Select the best twilight image from all the stages',
        subTitleJp: '夕暮れのシーンからお気に入りを選びました。',
        type: 'awTwilite'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img9665.jpg',
        id: 5,
        title: 'BEST NIGHT',
        titleJp: 'ナイト部門',
        subTitle: 'Select the best night image from all the stages',
        subTitleJp: '夜景の中からお気に入りを選びました。',
        type: 'awNight'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',
        id: 6,
        title: 'BEST VEHICLE',
        titleJp: 'ビークル部門',
        subTitle: 'Select the best vehicle image from all the stages',
        subTitleJp: '車、船など乗り物の画像から一番のお気に入りを選びました。',
        type: 'awVehicle'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/img1875base.jpg',
        id: 7,
        title: 'BEST COMPOSIT',
        titleJp: '合成部門',
        subTitle: 'Select the best composit image from all the stages',
        subTitleJp: '３Dモデルの画像合成、アニメーション画像から一番のお気に入りを選びました。',
        type: 'awComposit'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img0749a1x1.jpg',
        id: 8,
        title: 'BEST HDR',
        titleJp: 'ＨＤＲ部門',
        subTitle: 'Select the best HDR image from all the stages',
        subTitleJp: 'すべてのＨＤＲ画像から一番のお気に入りを選びました。',
        type: 'awHdr'
      }]

    };
  },

  computed: {
    meetups: function meetups() {
      return this.$store.getters.featuredMeetups;
    },
    meetupsFiltersType: function meetupsFiltersType() {
      // console.log('meetupsFiltersType')
      return this.$store.getters.featuredMeetupsFiltersType(this.id);
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },

  methods: {
    onLoadMeetup: function onLoadMeetup(id) {
      this.$router.push('/post/' + id);
    },
    getYear: function getYear(value) {
      var date = new Date(value);
      return date.getFullYear().toString();
    },
    goBack: function goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    }
  }
});

/***/ }),

/***/ "HYtK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  methods: {
    // onBack () {
    //   this.$router.push('/home' )

    goBack: function goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    }
  },
  computed: {
    meetup: function meetup() {
      return this.$store.getters.loadedMeetup(this.id);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsCreator: function userIsCreator() {
      if (!this.userIsAuthenticated) {
        return false;
      }
      return this.$store.getters.user.id === this.meetup.creatorId;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  }

  // data () {
  //   return {
  //     meetups: [
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2016/12/shishimai_title1.jpg',id:1, title:'獅子舞'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/02/kobe_again_title_stage2.jpg',id:2, title:'ＫＯＢＥ ＡＧＡＩＮ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/03/rusted_car_title2.jpg',id:3, title:'ＲＵＳＴＥＤ ＣＡＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',id:4, title:'Vintage Car'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/04/retoro_car_title.jpg',id:5, title:'ＲＥＴＲＯ ＣＡＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/Stage6_title.jpg',id:6, title:'瀬戸埠頭の見える岬でＨＤＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/haruyoi_title2.jpg',id:7, title:'倉敷春宵あかり'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/tamanoFes_title21.jpg',id:8, title:'たまの港フェスティバルでＨＤＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/a-bombe-dome.jpg',id:9, title:'Ａ‐ＢＯＭＢ ＤＯＭＥ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/broad_title3.jpg',id:10, title:'黒島ビーナスロード'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2946_title10.jpg',id:11, title:'Building in Sky'}
  //     ]
  //   }
  // }
});

/***/ }),

/***/ "IJxs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDetailsDialog_vue__ = __webpack_require__("Cpyz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8c4601_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDetailsDialog_vue__ = __webpack_require__("4iN8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDetailsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c8c4601_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDetailsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__ = __webpack_require__("uqrR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    loadedMeetups: [
    //   {
    //     imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/4/47/New_york_times_square-terabass.jpg',
    //     id: 'afajfjadfaadfa323',
    //     title: 'Meetup in New York',
    //     date: new Date(),
    //     location: 'New York',
    //     description: 'New York, New York!'
    //   },
    //   {
    //     imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/7/7a/Paris_-_Blick_vom_gro%C3%9Fen_Triumphbogen.jpg',
    //     id: 'aadsfhbkhlk1241',
    //     title: 'Meetup in Paris',
    //     date: new Date(),
    //     location: 'Paris',
    //     description: 'It\'s Paris!'
    //   }
    {
      imageUrl: '',
      id: '',
      title: '',
      date: new Date(),
      location: '',
      description: '',
      category: '',
      stageNo: '',
      tag: '',
      type: '',
      link: ''
    }],
    user: null,
    loading: false,
    error: null
  },
  mutations: {
    registerUserForMeetup: function registerUserForMeetup(state, payload) {
      var id = payload.id;
      if (state.user.registeredMeetups.findIndex(function (meetup) {
        return meetup.id === id;
      }) >= 0) {
        return;
      }
      state.user.registeredMeetups.push(id);
      state.user.fbKeys[id] = payload.fbKey;
    },
    unregisterUserFromMeetup: function unregisterUserFromMeetup(state, payload) {
      var registeredMeetups = state.user.registeredMeetups;
      registeredMeetups.splice(registeredMeetups.findIndex(function (meetup) {
        return meetup.id === payload;
      }), 1);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_reflect_delete_property___default()(state.user.fbKeys, payload);
    },
    setLoadedMeetups: function setLoadedMeetups(state, payload) {
      state.loadedMeetups = payload;
    },
    createMeetup: function createMeetup(state, payload) {
      state.loadedMeetups.push(payload);
    },
    updateMeetup: function updateMeetup(state, payload) {
      var meetup = state.loadedMeetups.find(function (meetup) {
        return meetup.id === payload.id;
      });
      if (payload.title) {
        meetup.title = payload.title;
      }
      if (payload.link) {
        meetup.link = payload.link;
      }
      if (payload.description) {
        meetup.description = payload.description;
      }

      if (payload.tag) {
        updateObj.tag = payload.tag;
      }
      if (payload.stageNo) {
        updateObj.stageNo = payload.stageNo;
      }

      if (payload.date) {
        meetup.date = payload.date;
      }
    },
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    registerUserForMeetup: function registerUserForMeetup(_ref, payload) {
      var commit = _ref.commit,
          getters = _ref.getters;

      commit('setLoading', true);
      var user = getters.user;
      __WEBPACK_IMPORTED_MODULE_4_firebase__["database"]().ref('/users/' + user.id).child('/registrations/').push(payload).then(function (data) {
        commit('setLoading', false);
        commit('registerUserForMeetup', { id: payload, fbKey: data.key });
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    unregisterUserFromMeetup: function unregisterUserFromMeetup(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('setLoading', true);
      var user = getters.user;
      if (!user.fbKeys) {
        return;
      }
      var fbKey = user.fbKeys[payload];
      __WEBPACK_IMPORTED_MODULE_4_firebase__["database"]().ref('/users/' + user.id + '/registrations/').child(fbKey).remove().then(function () {
        commit('setLoading', false);
        commit('unregisterUserFromMeetup', payload);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    loadMeetups: function loadMeetups(_ref3) {
      var commit = _ref3.commit;

      commit('setLoading', true);
      // firebase.database().ref('meetups').once('value')
      __WEBPACK_IMPORTED_MODULE_4_firebase__["database"]().ref('tourdehdr').once('value').then(function (data) {
        var meetups = [];
        var obj = data.val();
        for (var key in obj) {
          meetups.push({
            id: key,
            title: obj[key].title,
            description: obj[key].description,
            imageUrl: obj[key].imageUrl,
            date: obj[key].date,
            location: obj[key].location,
            creatorId: obj[key].creatorId,
            category: obj[key].category,
            stageNo: obj[key].stageNo,
            tag: obj[key].tag,
            type: obj[key].type,
            link: obj[key].link

          });
        }
        commit('setLoadedMeetups', meetups);
        commit('setLoading', false);
      }).catch(function (error) {
        console.log(error);
        commit('setLoading', false);
      });
    },
    createMeetup: function createMeetup(_ref4, payload) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      var meetup = {
        title: payload.title,
        category: payload.category,
        stageNo: payload.stageNo,
        tag: payload.tag,
        type: payload.type,
        link: payload.link,
        location: payload.location,
        // imageUrl: payload.imageUrl,
        description: payload.description,
        date: payload.date.toISOString(),
        creatorId: getters.user.id
      };
      var imageUrl = void 0;
      var key = void 0;
      __WEBPACK_IMPORTED_MODULE_4_firebase__["database"]().ref('tourdehdr').push(meetup).then(function (data) {
        key = data.key;
        return key;
      }).then(function (key) {
        var filename = payload.image.name;
        var ext = filename.slice(filename.lastIndexOf('.'));
        return __WEBPACK_IMPORTED_MODULE_4_firebase__["storage"]().ref('tourdehdr/' + key + '.' + ext).put(payload.image);
      }).then(function (fileData) {
        imageUrl = fileData.metadata.downloadURLs[0];
        return __WEBPACK_IMPORTED_MODULE_4_firebase__["database"]().ref('tourdehdr').child(key).update({ imageUrl: imageUrl });
      }).then(function () {
        commit('createMeetup', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, meetup, {
          imageUrl: imageUrl,
          id: key
        }));
      }).catch(function (error) {
        console.log(error);
      });
      // firebase.database().ref('meetups').push(meetup).then((data) => {
      //   key = data.key
      //    return key
      //  })
      //  .then(key => {
      //    const filename = payload.image.name
      //    const ext = filename.slice(filename.lastIndexOf('.'))
      //    return firebase.storage().ref('meetups/' + key + '.' + ext).put(payload.image)
      //  })
      //  .then(fileData => {
      //    imageUrl = fileData.metadata.downloadURLs[0]
      //    return firebase.database().ref('meetups').child(key).update({imageUrl: imageUrl})
      //  })
      //  .then(() => {
      //    commit('createMeetup', {
      //      ...meetup,
      //      imageUrl: imageUrl,
      //      id: key
      //    })
      //  })
      //  .catch((error) => {
      //    console.log(error)
      //  })
      // Reach out to firebase and store it
    },
    updateMeetupData: function updateMeetupData(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setLoading', true);
      // commit('clearError')
      var updateObj = {};
      if (payload.title) {
        updateObj.title = payload.title;
      }
      if (payload.link) {
        updateObj.link = payload.link;
      }
      if (payload.description) {
        updateObj.description = payload.description;
      }
      if (payload.tag) {
        updateObj.tag = payload.tag;
      }
      if (payload.stageNo) {
        updateObj.stageNo = payload.stageNo;
      }

      if (payload.date) {
        updateObj.date = payload.date;
      }

      __WEBPACK_IMPORTED_MODULE_4_firebase__["database"]().ref('tourdehdr').child(payload.id).update(updateObj).then(function () {
        commit('setLoading', false);
        commit('updateMeetup', payload);
      }).catch(function (error) {
        commit('setLoading', false);
        // commit('setError', error)
        console.log(error);
      });
    },
    signUserUp: function signUserUp(_ref6, payload) {
      var commit = _ref6.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_4_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          registeredMeetups: [],
          fbKeys: {}
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    signUserIn: function signUserIn(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setLoading', true);
      commit('clearError');
      __WEBPACK_IMPORTED_MODULE_4_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        commit('setLoading', false);
        var newUser = {
          id: user.uid,
          registeredMeetups: [],
          fbKeys: {}
        };
        commit('setUser', newUser);
      }).catch(function (error) {
        commit('setLoading', false);
        commit('setError', error);
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setUser', { id: payload.uid, registeredMeetups: [], fbKeys: {} });
    },
    logout: function logout(_ref9) {
      var commit = _ref9.commit;

      __WEBPACK_IMPORTED_MODULE_4_firebase__["auth"]().signOut();
      commit('setUser', null);
    },
    clearError: function clearError(_ref10) {
      var commit = _ref10.commit;

      commit('clearError');
    }
  },
  getters: {
    loadedMeetups: function loadedMeetups(state) {
      return state.loadedMeetups.sort(function (meetupA, meetupB) {
        // console.log('titelA: ' + meetupA.title)
        // console.log('titelB: ' + meetupB.title)
        // console.log('dateA: ' + meetupA.date)
        // console.log('dateB: ' + meetupB.date)
        // return meetupA.date > meetupB.date
        return meetupA.date < meetupB.date ? 1 : -1;
      });
    },
    loadedMeetupsStageNo: function loadedMeetupsStageNo(state) {
      return state.loadedMeetups.sort(function (meetupA, meetupB) {
        // console.log('titelA: ' + meetupA.title)
        // console.log('titelB: ' + meetupB.title)
        // console.log('dateA: ' + meetupA.date)
        // console.log('dateB: ' + meetupB.date)
        // return meetupA.date > meetupB.date
        return meetupA.stageNo > meetupB.stageNo ? 1 : -1;
      });
    },
    featuredMeetups: function featuredMeetups(state, getters) {
      //   return getters.loadedMeetups.slice(0, 5)
      return getters.loadedMeetups;
    },
    loadedMeetup: function loadedMeetup(state) {
      // console.log('loadedMeetupStage')
      // console.log('state ' + state )
      return function (meetupId) {
        // console.log('meetupId ' + meetupId)
        return state.loadedMeetups.find(function (meetup) {
          // console.log('meetup.id ' + meetup.id)
          // console.log('meetup.stage ' + meetup.stage)
          // console.log('meetupid ' + meetup.stage)
          return meetup.id === meetupId;
        });
      };
    },
    loadedMeetupsFilters: function loadedMeetupsFilters(state) {
      return state.loadedMeetups.filter(function (meetup, index) {
        // console.log('loadedMeetupsFilters')
        // console.log('titelA: ' + meetupA.title)
        // console.log('titelB: ' + meetupB.title)
        // console.log('dateA: ' + meetupA.date)
        // console.log('dateB: ' + meetupB.date)
        // return meetupA.date > meetupB.date
        return meetup.type == 'adPost';
      });
    },
    featuredMeetupsFilters: function featuredMeetupsFilters(state, getters) {
      // console.log(' featuredMeetupsFilters')

      //   return getters.loadedMeetups.slice(0, 5)
      return getters.loadedMeetupsFilters;
    },
    featuredMeetupsFiltersType: function featuredMeetupsFiltersType(state, getters) {
      // console.log('loadedMeetupStage')
      // console.log('state ' + state )
      return function (meetupId) {
        // console.log('meetupId ' + meetupId)
        return getters.loadedMeetupsStageNo.filter(function (meetup) {
          return meetup.type === meetupId;
        });
      };
    },
    user: function user(state) {
      return state.user;
    },
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});
// var filtered = [12, 5, 8, 130, 44].filter(function(element, index, array) {
//   return (element >= 10);
// });
// loadedMeetupCategory (state) {
//   return (category) => {
//     return state.loadedMeetups.filter((meetup) => {
//       return meetup.category === category
//     })
//   }

/***/ }),

/***/ "Ig/e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iwr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('back-to-top',{staticStyle:{"opacity":".5","bottom":"20px","right":"5px","padding":"10px","border-radius":"50%","width":"50px","height":"50px","background-color":"red"},attrs:{"visibleOffset":"400","text":"TOP"}}),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","width":7,"size":70}}):_vm._e()],1)],1),_vm._v(" "),(!_vm.loading)?_c('v-layout',{staticClass:"content-inner",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg8":"","xl8":""}},[_c('v-carousel',{staticClass:"carusel-style",staticStyle:{"cursor":"pointer"},attrs:{"hide-controls":""}},_vm._l((_vm.meetups),function(meetup){return (meetup.type == 'stage')?_c('v-carousel-item',{key:meetup.id,staticClass:"item-position"},[_c('img',{attrs:{"src":meetup.imageUrl,"width":"100%","height":"auto","alt":"meetup.title"}})]):_vm._e()}))],1)],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md11":"","lg8":"","xl8":""}},[_c('h5',{staticClass:"white--text pt-3"},[_vm._v("TOURdeHDR+2017 STAGE LIST")])])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.meetups),function(meetup,index){return (meetup.type == 'stage')?_c('v-layout',{key:meetup.id,staticClass:"mb-2 ",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md11":"","lg8":"","xl8":""}},[(!_vm.loading)?_c('v-card',{staticClass:"card-block"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":"","md4":"","lg3":"","xl3":""}},[_c('div',{staticClass:"image-inner"},[_c('img',{staticClass:"image",attrs:{"src":meetup.imageUrl,"alt":"lorem","width":"100%","height":"auto"}})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md8":"","lg9":"","xl9":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('p',{staticClass:"white--text mb-0"},[_vm._v("STAGE "+_vm._s(meetup.stageNo))]),_vm._v(" "),_c('h5',{staticClass:"white--text mb-0"},[_vm._v(" "+_vm._s(meetup.title))]),_vm._v(" "),_c('p',{staticClass:"white--text mb-0"},[_vm._v(" "+_vm._s(_vm._f("date")(meetup.date)))]),_vm._v(" "),_c('v-btn',{attrs:{"small":""},on:{"click":function($event){_vm.onLoadMeetup (meetup.category)}}},[_vm._v("Stage Photos"),_c('v-icon',{staticClass:"ml-0 pl-0",attrs:{"color":"grey darken-1"}},[_vm._v("chevron_right")])],1)],1)])],1)],1)],1)],1):_vm._e()],1)],1):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IxJE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","x12":""}},[_c('div',{staticClass:"page-title pt-3"},[_vm._v("DIGEST "),_c('span',{staticClass:"title-bar"},[_vm._v("|")]),_vm._v(" 2017")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","x12":""}},[_c('v-card',{staticClass:"grid card-block"},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.meetups),function(meetup){return (meetup.category == _vm.id  &&  meetup.type == 'post'  &&_vm.getYear( meetup.date) == '2017')?_c('v-flex',{key:meetup.id,staticClass:"image-inner",attrs:{"xs12":"","sm12":"","md4":"","lg2":"","xl2":""}},[_c('div',{staticClass:"image-border"},[_c('img',{staticClass:"image",staticStyle:{"cursor":"pointer"},attrs:{"src":meetup.imageUrl,"alt":meetup.title},on:{"click":function($event){_vm.onLoadMeetup(meetup.id)}}}),_vm._v(" "),_c('p',{staticClass:"image-cap "},[_vm._v(" "+_vm._s(meetup.title.slice(0,12))+"...")])])]):_vm._e()}))],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"left"},attrs:{"xs12":"","sm12":"","md6":"","lg4":"","xl4":""}},[_c('v-btn',{on:{"click":function($event){_vm.goBack(_vm.meetupType)}}},[_vm._v("\n              Back\n                "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IzAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J89A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',[_c('h1',{staticClass:"ma-5"},[_vm._v("404 NOT FOUND PAGE!")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KNNh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KbQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","offset-sm1":"","offset-md2":""}},[_c('v-card',{staticClass:"grid card-block"},[_c('v-subheader',[_vm._v("2017")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.meetups),function(meetup){return (meetup.type == 'stage' &&  _vm.getYear( meetup.date) == '2017')?_c('v-flex',{key:meetup.id,staticStyle:{"cursor":"pointer"},attrs:{"xs12":"","sm12":"","md6":"","lg4":"","x4":""},on:{"click":function($event){_vm.onLoadMeetup(meetup.id)}}},[_c('div',{staticClass:"image-inner"},[_c('img',{staticClass:"image",attrs:{"src":meetup.imageUrl,"alt":"lorem","width":"100%","height":"auto"}})])]):_vm._e()}))],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xs12":"","sm10":"","md8":"","offset-sm1":"","offset-md2":""}},[_c('v-btn',{on:{"click":_vm.onBack}},[_vm._v("\n              Back\n                "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L4X2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"350px","persistent":""},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-btn',{attrs:{"slot":"activator","accent":""},slot:"activator"},[_c('v-icon',[_vm._v("edit")]),_vm._v("  Date\n  ")],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card-title',[_vm._v("Edit Meetup Date")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-date-picker',{staticStyle:{"width":"100%"},attrs:{"actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.editDialog = false}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.onSaveChanges($event)}}},[_vm._v("Save")])]}}]),model:{value:(_vm.editableDate),callback:function ($$v) {_vm.editableDate=$$v},expression:"editableDate"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc2637d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("u/EQ");
function injectStyle (ssrContext) {
  __webpack_require__("Ig/e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc2637d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MSct":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_titlePhoto_vue__ = __webpack_require__("vyVU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1bb8240_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_titlePhoto_vue__ = __webpack_require__("j6rb");
function injectStyle (ssrContext) {
  __webpack_require__("O5Ih")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1bb8240"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_titlePhoto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1bb8240_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_titlePhoto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_styl__ = __webpack_require__("tLfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_backtotop__ = __webpack_require__("vJRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters_date__ = __webpack_require__("5TPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Shared_Alert_vue__ = __webpack_require__("yVzT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_digest_edit_EditDetailsDialog_vue__ = __webpack_require__("IJxs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_digest_edit_EditDateDialog_vue__ = __webpack_require__("RTn/");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_backtotop__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', __WEBPACK_IMPORTED_MODULE_10__filters_date__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-alert', __WEBPACK_IMPORTED_MODULE_11__components_Shared_Alert_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-details-dialog', __WEBPACK_IMPORTED_MODULE_12__components_digest_edit_EditDetailsDialog_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-date-dialog', __WEBPACK_IMPORTED_MODULE_13__components_digest_edit_EditDateDialog_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('app-edit-date-dialog', __WEBPACK_IMPORTED_MODULE_13__components_digest_edit_EditDateDialog_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* store */],
  Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */],
  BackToTop: __WEBPACK_IMPORTED_MODULE_5_vue_backtotop__["a" /* default */],
  // template: '<App/>',
  // components: { App }


  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */]);
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_7_firebase__["initializeApp"]({
      apiKey: 'AIzaSyA6tdW1nraEFMImrgR4AaVCO6qrJqRw5kc',
      authDomain: 'oauth3-11020.firebaseapp.com',
      databaseURL: 'https://oauth3-11020.firebaseio.com',
      projectId: 'oauth3-11020',
      storageBucket: 'oauth3-11020.appspot.com'
    });
    __WEBPACK_IMPORTED_MODULE_7_firebase__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
      }
    });
    this.$store.dispatch('loadMeetups');
  }
});

/***/ }),

/***/ "O5Ih":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OjF9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P8GW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  name: 'carrousel',
  data: function data() {
    return {
      dspCaption: false,
      awards: [{ imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0208b1x1.jpg',
        id: 1,
        title: 'BEST TITLE',
        titleJp: 'タイトル部門',
        subTitle: 'Select the best title image from all the stages',
        subTitleJp: '２０１７年に投稿した１１ステージのタイトル画像から最も気に入っているデザインを選びました。',
        type: 'awStage'
      }, { imageUrl: ' http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0259.jpg',
        id: 2,
        title: 'BEST STAGE',
        titleJp: 'ベストステージ部門',
        subTitle: 'Select the best post image from all the stages',
        subTitleJp: '各ステージの中から一番のお気に入りを選びました。',
        type: 'awPost'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2931.jpg',
        id: 3,
        title: 'BEST DAYTIME',
        titleJp: 'デイタイム部門',
        subTitle: 'Select the best Daytime image from all the stages',
        subTitleJp: '昼間のシーンからお気に入りを選びました。',
        type: 'awDaytime'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/b_road_panorama1b.jpg',
        id: 4,
        title: 'BEST TWILIGHT',
        titleJp: 'トワイライト部門',
        subTitle: 'Select the best twilight image from all the stages',
        subTitleJp: '夕暮れのシーンからお気に入りを選びました。',
        type: 'awTwilite'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img9665.jpg',
        id: 5,
        title: 'BEST NIGHT',
        titleJp: 'ナイト部門',
        subTitle: 'Select the best night image from all the stages',
        subTitleJp: '夜景の中からお気に入りを選びました。',
        type: 'awNight'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',
        id: 6,
        title: 'BEST VEHICLE',
        titleJp: 'ビークル部門',
        subTitle: 'Select the best vehicle image from all the stages',
        subTitleJp: '車、船など乗り物の画像から一番のお気に入りを選びました。',
        type: 'awVehicle'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/img1875base.jpg',
        id: 7,
        title: 'BEST COMPOSIT',
        titleJp: '合成部門',
        subTitle: 'Select the best composit image from all the stages',
        subTitleJp: '３Dモデルの画像合成、アニメーション画像から一番のお気に入りを選びました。',
        type: 'awComposit'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img0749a1x1.jpg',
        id: 8,
        title: 'BEST HDR',
        titleJp: 'ＨＤＲ部門',
        subTitle: 'Select the best HDR image from all the stages',
        subTitleJp: 'すべてのＨＤＲ画像から一番のお気に入りを選びました。',
        type: 'awHdr'
      }],
      contents: [{
        title: 'Content 1',
        bg_color: '#7bbff9'
      }, {
        title: 'Content 2',
        bg_color: '#f16972'
      }, {
        title: 'Content 3',
        bg_color: '#20d2a3'
      }],
      transition_name: 'show-next',
      visible_content: 0
    };
  },


  methods: {
    onBack: function onBack() {
      this.$router.push('/top');
    },
    onLoadMeetupPost: function onLoadMeetupPost(id) {
      this.$router.push('/post/' + id);
    },
    onLoadMeetupThumnail: function onLoadMeetupThumnail(id) {
      this.$router.push('/thumnail/' + id);
    },
    onLoadMeetupEntry: function onLoadMeetupEntry(id) {
      this.$router.push('/entry/' + id);
    },
    back: function back() {
      this.transition_name = 'show-prev';
      this.visible_content--;
    },
    next: function next() {
      this.transition_name = 'show-next';
      this.visible_content++;
    },
    dspCaptionSw: function dspCaptionSw() {
      this.dspCaption = !this.dspCaption;
    }
  },
  computed: {
    meetups: function meetups() {
      return this.$store.getters.featuredMeetups;
    },

    // meetupsFilters () {
    //   console.log('meetupsFilters')
    //   return this.$store.getters.featuredMeetupsFilters
    // },
    meetupsFiltersType: function meetupsFiltersType() {
      // console.log('meetupsFiltersType')
      return this.$store.getters.featuredMeetupsFiltersType(this.id);
    },

    //   meetup () {
    //     return this.$store.getters.loadedMeetup(this.id)
    //   },
    //   userIsAuthenticated () {
    //     return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    //   },
    //   userIsCreator () {
    //     if (!this.userIsAuthenticated) {
    //       return false
    //     }
    //     return this.$store.getters.user.id === this.meetup.creatorId
    //   },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    isCaption: function isCaption() {
      this.isCaption = !this.isCaption;
    }
  }

});

/***/ }),

/***/ "QtCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateStage_vue__ = __webpack_require__("+dOB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e01940c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateStage_vue__ = __webpack_require__("rk/P");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateStage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e01940c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateStage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RNi4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postPhoto_vue__ = __webpack_require__("HYtK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b9ba88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postPhoto_vue__ = __webpack_require__("F7mD");
function injectStyle (ssrContext) {
  __webpack_require__("XdQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53b9ba88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_postPhoto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b9ba88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_postPhoto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RTn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDateDialog_vue__ = __webpack_require__("rXk7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32da004f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDateDialog_vue__ = __webpack_require__("L4X2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDateDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32da004f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDateDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S25E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TCqd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XSTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__ = __webpack_require__("Arj8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3aad90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__ = __webpack_require__("cJmY");
function injectStyle (ssrContext) {
  __webpack_require__("TCqd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a3aad90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_top_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a3aad90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_top_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XdQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_error__ = __webpack_require__("Zazt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_top__ = __webpack_require__("XSTL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_digest_stagePhoto__ = __webpack_require__("/XfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_digest_titlePhoto__ = __webpack_require__("MSct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_digest_stageThumnail__ = __webpack_require__("CrjG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_digest_postPhoto__ = __webpack_require__("RNi4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_digest_CreateStage__ = __webpack_require__("QtCm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_user_Signin__ = __webpack_require__("tA1F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_awards_awardsBest__ = __webpack_require__("HIvf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_awards_awardsEntry__ = __webpack_require__("mWBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_awards_awardsThumnail__ = __webpack_require__("sgwl");















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  base: '/web3/digest2017/',

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash === '#page-top' | to.hash === '#top') {
      console.log('to.hash:' + to.hash);
      return { x: 0, y: 0 };
    } else {
      return { selector: to.hash };
    }
  },

  routes: [{
    path: '/',
    name: 'MyRoot',
    component: __WEBPACK_IMPORTED_MODULE_4__components_top__["a" /* default */]
  }, {
    path: '/top',
    name: 'Top',
    component: __WEBPACK_IMPORTED_MODULE_4__components_top__["a" /* default */]
  }, {
    path: '/best/:id',
    name: 'Best',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_11__components_awards_awardsBest__["a" /* default */]
  }, {
    path: '/thumnail/:id',
    name: 'Thumnail',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_13__components_awards_awardsThumnail__["a" /* default */]
  }, {
    path: '/entry/:id',
    name: 'Entry',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_12__components_awards_awardsEntry__["a" /* default */]
  }, {
    path: '/stageThumnail/:id',
    name: 'StageThumnail',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_7__components_digest_stageThumnail__["a" /* default */]
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/stage',
    name: 'Stage',
    component: __WEBPACK_IMPORTED_MODULE_5__components_digest_stagePhoto__["a" /* default */]
  }, {
    path: '/title',
    name: 'Title',
    component: __WEBPACK_IMPORTED_MODULE_6__components_digest_titlePhoto__["a" /* default */]
  }, {
    path: '/title/:id',
    name: 'TitleId',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_6__components_digest_titlePhoto__["a" /* default */]
  }, {
    path: '/post',
    name: 'Post',
    component: __WEBPACK_IMPORTED_MODULE_8__components_digest_postPhoto__["a" /* default */]
  }, {
    path: '/post/:id',
    name: 'PostId',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_8__components_digest_postPhoto__["a" /* default */]
  },

  // {
  //   path: '/meetup/new',
  //   name: 'CreateMeetup',
  //   component: CreateMeetup,
  //   beforeEnter: AuthGuard
  // },
  {
    path: '/upload',
    name: 'CreateStage',
    component: __WEBPACK_IMPORTED_MODULE_9__components_digest_CreateStage__["a" /* default */]
    // beforeEnter: AuthGuard
  },
  // {
  //   path: '/meetups/:id',
  //   name: 'Meetup',
  //   props: true,
  //   component: Meetup
  // },
  // {
  //   path: '/profile',
  //   name: 'Profile',
  //   component: Profile,
  //   beforeEnter: AuthGuard
  // },
  // {
  //   path: '/signup',
  //   name: 'Signup',
  //   component: Signup
  // },
  {
    path: '/signin',
    name: 'Signin',
    component: __WEBPACK_IMPORTED_MODULE_10__components_user_Signin__["a" /* default */]
  }, {
    path: '/error',
    name: 'Error',
    component: __WEBPACK_IMPORTED_MODULE_3__components_error__["a" /* default */]
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_3__components_error__["a" /* default */]
  }]

}));

/***/ }),

/***/ "Zazt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__ = __webpack_require__("7TUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73749ffa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__ = __webpack_require__("J89A");
function injectStyle (ssrContext) {
  __webpack_require__("KNNh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73749ffa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73749ffa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cHSO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cJmY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('back-to-top',{staticStyle:{"opacity":".5","bottom":"20px","right":"5px","padding":"10px","border-radius":"50%","width":"50px","height":"50px","background-color":"red"},attrs:{"visibleOffset":"400","text":"TOP"}}),_vm._v(" "),_c('v-layout',{staticClass:"py-5",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"page-title pt-3 amber--text"},[_vm._v("TOURdeHDR+ AWARD 2017")]),_vm._v(" "),_c('h4',{staticClass:"shimmer "},[_vm._v("My Favorite HDR Photos Taken At This Year  ")])]),_vm._v(" "),_c('v-layout',{staticClass:"pb-4",attrs:{"row":"","wrap":"","justify-space-between":""}},_vm._l((_vm.awards),function(award){return _c('v-flex',{key:award.id,attrs:{"d-flex":""}},[_c('router-link',{attrs:{"to":'#' + award.type}},[_c('v-btn',{staticClass:"award-btn",attrs:{"outline":"","color":"indigo"}},[_vm._v("\n            "+_vm._s(award.title)+"\n            ")])],1)],1)})),_vm._v(" "),_vm._l((_vm.awards),function(award){return _c('div',{key:award.id},[_c('a',{attrs:{"id":award.type}}),_vm._v(" "),_c('v-parallax',{attrs:{"src":award.imageUrl,"width":"100%","height":"460"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('h4',{staticClass:"title-image mx-2"},[_vm._v("AWARDS")]),_vm._v(" "),_c('h1',{staticClass:"title-image mx-2 "},[_vm._v(_vm._s(award.title))]),_vm._v(" "),_c('h4',{staticClass:"title-image mx-2"},[_vm._v(_vm._s(award.subTitle))]),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"round":"","color":"indigo","dark":""},on:{"click":function($event){_vm.onLoadMeetupAwards(award.type)}}},[_vm._v("View More")])],1)])],1),_vm._v(" "),_c('section',[_c('v-layout',{staticClass:"my-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sx12":"","sm12":"","md6":"","lg6":"","offset-lg3":"","xl6":"","offset-xl3":""}},[_c('div',[_c('h3',{staticClass:"title-image px-4 "},[_vm._v(_vm._s(award.titleJp))]),_vm._v(" "),_c('p',{staticClass:"px-4 mt-1 "},[_vm._v(_vm._s(award.subTitleJp))]),_vm._v(" "),_c('v-layout',{staticClass:"my-4",attrs:{"row":"","wrap":""}},_vm._l((_vm.meetups),function(meetup,index){return (award.type == meetup.type)?_c('v-flex',{key:meetup.id,attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('span',{staticClass:" mt-1",on:{"click":function($event){_vm.onLoadMeetupPost (meetup.id)}}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',[_vm._v("keyboard_arrow_right")]),_vm._v(_vm._s(meetup.title))],1)],1)]):_vm._e()})),_vm._v(" "),_c('v-btn',{staticClass:"ml-4",attrs:{"round":"","color":"indigo","dark":""},on:{"click":function($event){_vm.onLoadMeetupAwards(award.type)}}},[_vm._v(_vm._s(award.titleJp)+"を見る")])],1)])],1)],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "epSO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j6rb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(!_vm.loading)?_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm11":"","md10":"","lg8":"","xl8":""}},_vm._l((_vm.meetups),function(meetup){return (meetup.category == _vm.id && meetup.type == 'stage')?_c('v-card',{key:meetup.id,staticClass:"pl-2 pr-2"},[_c('v-card-title',[_c('h6',{staticClass:"white--text"},[_vm._v(_vm._s(meetup.title))])]),_vm._v(" "),_c('img',{attrs:{"src":meetup.imageUrl,"width":"100%","height":"auto"}})],1):_vm._e()}))],1):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm11":"","md8":""}},[_c('h5',{staticClass:"white--text pt-3"},[_vm._v("TOURdeHDR+2017 STAGE DIGEST")])])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm11":"","md10":"","lg8":"","xl8":""}},[_c('v-card',{staticClass:"grid card-block"},[_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{staticClass:"pt-3 pl-1 pr-1",attrs:{"row":"","wrap":""}},_vm._l((_vm.meetups),function(meetup){return (meetup.category == _vm.id && meetup.type == 'post')?_c('v-flex',{key:meetup.id,staticStyle:{"cursor":"pointer"},attrs:{"xs12":"","sm12":"","md6":"","lg4":"","xl4":""},on:{"click":function($event){_vm.onLoadMeetup (meetup.id)}}},[_c('div',{staticClass:"image-inner"},[_c('img',{staticClass:"image",attrs:{"src":meetup.imageUrl,"alt":"lorem","width":"100%","height":"auto"}})])]):_vm._e()}))],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),(!_vm.loading)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xs12":"","sm11":"","md8":""}},[_c('v-btn',{on:{"click":_vm.onBack}},[_vm._v("\n              Back\n                "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kgXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602f1c54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("Iwr5");
function injectStyle (ssrContext) {
  __webpack_require__("lft+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-602f1c54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602f1c54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lft+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mJcB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  computed: {
    meetups: function meetups() {
      return this.$store.getters.featuredMeetups;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  // data () {
  //   return {
  //     meetups: [
  //          {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2016/12/shishimai_title1.jpg',id:1, title:'獅子舞'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/02/kobe_again_title_stage2.jpg',id:2, title:'ＫＯＢＥ ＡＧＡＩＮ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/03/rusted_car_title2.jpg',id:3, title:'ＲＵＳＴＥＤ ＣＡＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',id:4, title:'Vintage Car'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/04/retoro_car_title.jpg',id:5, title:'ＲＥＴＲＯ ＣＡＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/Stage6_title.jpg',id:6, title:'瀬戸埠頭の見える岬でＨＤＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/haruyoi_title2.jpg',id:7, title:'倉敷春宵あかり'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/tamanoFes_title21.jpg',id:8, title:'たまの港フェスティバルでＨＤＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/a-bombe-dome.jpg',id:9, title:'Ａ‐ＢＯＭＢ ＤＯＭＥ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/broad_title3.jpg',id:10, title:'黒島ビーナスロード'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2946_title10.jpg',id:11, title:'Building in Sky'}
  //     ]
  //   }
  // },

  methods: {
    onLoadMeetup: function onLoadMeetup(id) {
      this.$router.push('/post/' + id);
    },
    getYear: function getYear(value) {
      var date = new Date(value);
      return date.getFullYear().toString();
    },
    onBack: function onBack() {
      this.$router.push('/home');
    }
  }
});

/***/ }),

/***/ "mWBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_awardsEntry_vue__ = __webpack_require__("62Cc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122f4fd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_awardsEntry_vue__ = __webpack_require__("E4rV");
function injectStyle (ssrContext) {
  __webpack_require__("epSO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-122f4fd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_awardsEntry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122f4fd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_awardsEntry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nnto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('div',{attrs:{"id":"top"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.awards),function(award){return (_vm.id == award.type)?_c('v-flex',{key:award.id},[_c('div',{staticClass:"page-title pt-3"},[_vm._v("AWARDS "),_c('span',{staticClass:"title-bar"},[_vm._v("|")]),_vm._v(" "+_vm._s(award.title))])]):_vm._e()})),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","width":7,"size":70}}):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"content-inner",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('div',{staticClass:"vue-carousel",attrs:{"id":"vue-carousel"}},[(!_vm.loading)?_c('transition',{attrs:{"name":_vm.transition_name}},_vm._l((_vm.meetupsFiltersType),function(meetup,index){return (_vm.visible_content == index)?_c('div',{key:index,staticClass:"vue-carousel_body"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"car-img",attrs:{"xs12":"","sm12":"","md12":"","lg9":"","xl9":""}},[_c('img',{staticClass:"carousel-img",attrs:{"src":meetup.imageUrl,"alt":meetup.title},on:{"click":function($event){_vm.onLoadMeetupEntry(meetup.id)}}})]),_vm._v(" "),_c('v-flex',{staticClass:"car-text",attrs:{"xs12":"","sm12":"","md12":"","lg3":"","xl3":""}},[_c('div',{staticClass:"car-text-grp"},[_c('h5',[_vm._v(_vm._s(meetup.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(meetup.category)+"    "+_vm._s(_vm._f("date")(meetup.date)))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.dspCaption),expression:"dspCaption"}]},[_vm._v(_vm._s(meetup.description.slice(0,80))+"...")]),_vm._v(" "),_c('div',{staticClass:"vue-carousel_footer"},[_c('button',{attrs:{"disabled":_vm.visible_content == 0},on:{"click":function($event){_vm.back()}}},[_c('v-icon',{attrs:{"coclor":"lightgray"}},[_vm._v("chevron_left")]),_vm._v("PREV")],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(index + 1)+" / "+_vm._s(_vm.meetupsFiltersType.length))]),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.visible_content == _vm.meetupsFiltersType.length - 1},on:{"click":function($event){_vm.next()}}},[_vm._v("NEXT"),_c('v-icon',{attrs:{"coclor":"lightgray"}},[_vm._v("chevron_right")])],1)]),_vm._v(" "),_c('div',{staticClass:"vue-carousel_footer"},[_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":function($event){_vm.onLoadMeetupThumnail(meetup.type)}}},[_c('v-icon',[_vm._v("border_all")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":function($event){_vm.onLoadMeetupEntry(meetup.id)}}},[_c('v-icon',[_vm._v("expand_more")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","small":""},on:{"click":function($event){_vm.dspCaptionSw()}}},[_c('v-icon',[_vm._v("insert_comment")])],1)],1)])])],1)],1):_vm._e()})):_vm._e()],1)])],1),_vm._v(" "),_c('v-flex',{staticClass:"ma-4",staticStyle:{"text-align":"left"},attrs:{"xs12":"","lg8":"","xl8":""}},[_c('v-btn',{on:{"click":_vm.onBack}},[_vm._v("\n              Back\n                "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pp7c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"error":"","dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rXk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['meetup'],
  data: function data() {
    return {
      editDialog: false,
      editableDate: null
    };
  },

  methods: {
    onSaveChanges: function onSaveChanges() {
      var newDate = new Date(this.meetup.date);
      var newDay = new Date(this.editableDate).getUTCDate();
      var newMonth = new Date(this.editableDate).getUTCMonth();
      var newYear = new Date(this.editableDate).getUTCFullYear();
      newDate.setUTCDate(newDay);
      newDate.setUTCMonth(newMonth);
      newDate.setUTCFullYear(newYear);
      this.$store.dispatch('updateMeetupData', {
        id: this.meetup.id,
        date: newDate
      });
    }
  },
  created: function created() {
    this.editableDate = new Date(this.meetup.date);
  }
});

/***/ }),

/***/ "rk/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('h5',[_vm._v("新規登録")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onCreateMeetup($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-btn',{staticClass:"error",on:{"click":_vm.onPickFile}},[_vm._v("Upload Image")]),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"type","label":"Type","id":"type","required":""},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"stageNo","label":"StageNo","id":"stageNo","required":""},model:{value:(_vm.stageNo),callback:function ($$v) {_vm.stageNo=$$v},expression:"stageNo"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"category","label":"Category/Stage","id":"category","required":""},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"tag","label":"Tag","id":"tag","required":""},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"location","label":"Location","id":"location","required":""},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"title","label":"Title","id":"title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"link","label":"Link Adress","id":"link","required":""},model:{value:(_vm.link),callback:function ($$v) {_vm.link=$$v},expression:"link"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('img',{attrs:{"src":_vm.imageUrl,"height":"150"}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-text-field',{attrs:{"name":"description","label":"Description","id":"description","multi-line":"","required":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('p',[_vm._v("Post Date ")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-date-picker',{model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-btn',{staticClass:"primary",attrs:{"disabled":!_vm.formIsValid,"type":"submit"}},[_vm._v("Create Meetup")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.onCancel}},[_vm._v("\n              Cancel\n                "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sgwl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_awardsThumnail_vue__ = __webpack_require__("vupU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce1a628_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_awardsThumnail_vue__ = __webpack_require__("8veW");
function injectStyle (ssrContext) {
  __webpack_require__("OjF9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ce1a628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_awardsThumnail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce1a628_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_awardsThumnail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tA1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__("5S4j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56589f41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__("u9mD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56589f41_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tLfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u/EQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire","dark":""}},[_c('v-navigation-drawer',{attrs:{"clipped":"","persistent":"","enable-resize-watcher":"","app":"","temporary":"","fixed":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.link}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)}))],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","fixed":"","clipped-left":""}},[_c('v-toolbar-title',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("AWARDS 2017")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{staticClass:"hidden-sm-only hidden-md-only hidden-lg-only hidden-xl-only ",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},_vm._l((_vm.menuItems),function(item){return _c('v-btn',{key:item.link,staticClass:"white--text",attrs:{"flat":"","to":item.link}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n            "+_vm._s(item.title)+"\n        ")],1)}))],1),_vm._v(" "),_c('main',{staticClass:"main-content"},[_c('router-view')],1),_vm._v(" "),_c('sub-footer',{staticClass:"subFooter"},[_c('v-layout',{staticClass:"ma-0 pa-0",attrs:{"justify-center":"","align-center":""}},[_c('v-btn',{staticStyle:{"padding-top":"1rem"},attrs:{"flat":"","href":'http://tourdehdr.sakuratan.com/site2/',"target":"_blank"}},[_c('p',{staticClass:"text-xs-center text-sm-center text-md-center text-lg-center text-xl-center white--text"},[_vm._v("TOURdeHDR+2017")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"ma-0 pa-0",attrs:{"justify-center":"","align-center":""}},[_c('v-tooltip',{attrs:{"right":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","large":"","href":'https://plus.google.com/+YoshiakiHiramatsu',"target":"_blank"},slot:"activator"},[_c('icon',{staticClass:"mb-1",attrs:{"name":"google-plus","scale":"2"}})],1),_vm._v(" "),_c('span',[_vm._v("Google+")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","large":"","href":'https://twitter.com/TOURdeHDR',"target":"_blank"},slot:"activator"},[_c('icon',{staticClass:"mb-1",attrs:{"name":"twitter","scale":"2"}})],1),_vm._v(" "),_c('span',[_vm._v("Twitter")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","large":"","href":'https://www.facebook.com/tourdehdr/',"target":"_blank"},slot:"activator"},[_c('icon',{staticClass:"mb-1",attrs:{"name":"facebook","scale":"2"}})],1),_vm._v(" "),_c('span',[_vm._v("Twitter")])],1)],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"app":""}},[(!_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.onLogin}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("lock_open")])],1):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.onUpload}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cloud_upload")])],1):_vm._e(),_vm._v(" "),(_vm.userIsAuthenticated)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.onLogout}},[_c('v-icon',{staticClass:"pr-2 mr-5",attrs:{"left":"","dark":""}},[_vm._v("exit_to_app")])],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u9mD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('app-alert',{attrs:{"text":_vm.error.message},on:{"dismissed":_vm.onDismissed}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.onSignin($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Mail","id":"email","type":"email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit","disabled":_vm.loading,"loading":_vm.loading}},[_vm._v("\n                    Sign in\n                     "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',{attrs:{"info":""}},[_vm._v("cached")])],1)]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.onLogout}},[_vm._v("\n                    Cancel\n                     "),_c('span',{staticClass:"custom-loader",attrs:{"slot":"loader"},slot:"loader"},[_c('v-icon',[_vm._v("cached")])],1)])],1)],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vupU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  data: function data() {
    return {

      awards: [{ imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0208b1x1.jpg',
        id: 1,
        title: 'BEST TITLE',
        titleJp: 'タイトル部門',
        subTitle: 'Select the best title image from all the stages',
        subTitleJp: '２０１７年に投稿した１１ステージのタイトル画像から最も気に入っているデザインを選びました。',
        type: 'awStage'
      }, { imageUrl: ' http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/07/img0259.jpg',
        id: 2,
        title: 'BEST STAGE',
        titleJp: 'ベストステージ部門',
        subTitle: 'Select the best post image from all the stages',
        subTitleJp: '各ステージの中から一番のお気に入りを選びました。',
        type: 'awPost'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2931.jpg',
        id: 3,
        title: 'BEST DAYTIME',
        titleJp: 'デイタイム部門',
        subTitle: 'Select the best Daytime image from all the stages',
        subTitleJp: '昼間のシーンからお気に入りを選びました。',
        type: 'awDaytime'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/b_road_panorama1b.jpg',
        id: 4,
        title: 'BEST TWILIGHT',
        titleJp: 'トワイライト部門',
        subTitle: 'Select the best twilight image from all the stages',
        subTitleJp: '夕暮れのシーンからお気に入りを選びました。',
        type: 'awTwilite'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img9665.jpg',
        id: 5,
        title: 'BEST NIGHT',
        titleJp: 'ナイト部門',
        subTitle: 'Select the best night image from all the stages',
        subTitleJp: '夜景の中からお気に入りを選びました。',
        type: 'awNight'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',
        id: 6,
        title: 'BEST VEHICLE',
        titleJp: 'ビークル部門',
        subTitle: 'Select the best vehicle image from all the stages',
        subTitleJp: '車、船など乗り物の画像から一番のお気に入りを選びました。',
        type: 'awVehicle'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/img1875base.jpg',
        id: 7,
        title: 'BEST COMPOSIT',
        titleJp: '合成部門',
        subTitle: 'Select the best composit image from all the stages',
        subTitleJp: '３Dモデルの画像合成、アニメーション画像から一番のお気に入りを選びました。',
        type: 'awComposit'
      }, { imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/img0749a1x1.jpg',
        id: 8,
        title: 'BEST HDR',
        titleJp: 'ＨＤＲ部門',
        subTitle: 'Select the best HDR image from all the stages',
        subTitleJp: 'すべてのＨＤＲ画像から一番のお気に入りを選びました。',
        type: 'awHdr'
      }]

    };
  },

  computed: {
    meetups: function meetups() {
      return this.$store.getters.featuredMeetups;
    },
    meetupsFiltersType: function meetupsFiltersType() {
      // console.log('meetupsFiltersType')
      return this.$store.getters.featuredMeetupsFiltersType(this.id);
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },

  methods: {
    onLoadMeetup: function onLoadMeetup(id) {
      this.$router.push('/post/' + id);
    },
    getYear: function getYear(value) {
      var date = new Date(value);
      return date.getFullYear().toString();
    },
    goBack: function goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    }
  }
});

/***/ }),

/***/ "vyVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['id'],
  computed: {
    meetups: function meetups() {
      return this.$store.getters.featuredMeetups;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  // data () {
  //   return {
  //     meetups: [
  //          {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2016/12/shishimai_title1.jpg',id:1, title:'獅子舞'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/02/kobe_again_title_stage2.jpg',id:2, title:'ＫＯＢＥ ＡＧＡＩＮ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/03/rusted_car_title2.jpg',id:3, title:'ＲＵＳＴＥＤ ＣＡＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2050/04/vintagecar_title1.jpg',id:4, title:'Vintage Car'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/04/retoro_car_title.jpg',id:5, title:'ＲＥＴＲＯ ＣＡＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/Stage6_title.jpg',id:6, title:'瀬戸埠頭の見える岬でＨＤＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/05/haruyoi_title2.jpg',id:7, title:'倉敷春宵あかり'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/08/tamanoFes_title21.jpg',id:8, title:'たまの港フェスティバルでＨＤＲ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/09/a-bombe-dome.jpg',id:9, title:'Ａ‐ＢＯＭＢ ＤＯＭＥ'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/broad_title3.jpg',id:10, title:'黒島ビーナスロード'},
  //         {imageUrl: 'http://tourdehdr.sakuratan.com/site2/wp-content/uploads/2017/10/img2946_title10.jpg',id:11, title:'Building in Sky'}
  //     ]
  //   }
  // },

  methods: {
    onLoadMeetup: function onLoadMeetup(id) {
      this.$router.push('/post/' + id);
    },
    onBack: function onBack() {
      this.$router.push('/home');
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//   export default {
//     data: () => ({
//       drawer: true
//     }),
//     props: {
//       source: String
//     }
//   }
/* harmony default export */ __webpack_exports__["a"] = ({
  // props: {
  //   source: String
  // },

  data: function data() {
    return {
      drawer: false,
      menuItems: [{ icon: 'account_balance', title: 'AWARDS', link: '/top' }, { icon: 'widgets', title: 'DIGEST', link: '/home'
        // {icon: '3d_rotation', title: 'COMPOSITE', link: '/model'}

      }]
    };
  },

  computed: {
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    }
  },
  methods: {
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
    },
    onLogin: function onLogin() {
      this.$router.push('/signin');
    },
    onUpload: function onUpload() {
      this.$router.push('/upload');
    }
  }
});

/***/ }),

/***/ "yVzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__("03pU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf4d7f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__("pp7c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf4d7f2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zh4g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a35da58e5cb4af8c22ba.js